import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '../../assets/eazy-messager-icon.svg';
import styles from './LoadingApp.module.scss';
const LoadingApp = () => {
    return (_jsx("div", { className: styles.container, children: _jsx(Icon, { className: styles.item }) }));
};
export default LoadingApp;
